
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 0 0.772277 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-34 -34)","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"#000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M44.505 48.248L48.409 46l-3.904-2.248z"}}),_c('path',{attrs:{"d":"M46 34c-6.626 0-12 5.374-12 12s5.374 12 12 12 12-5.374 12-12-5.374-12-12-12zm7.498 12.012s0 2.434-.309 3.607a1.878 1.878 0 01-1.321 1.322c-1.174.309-5.868.309-5.868.309s-4.682 0-5.868-.321a1.88 1.88 0 01-1.321-1.322C38.5 48.446 38.5 46 38.5 46s0-2.433.31-3.607a1.915 1.915 0 011.321-1.334C41.306 40.75 46 40.75 46 40.75s4.694 0 5.868.321a1.88 1.88 0 011.321 1.322c.322 1.174.31 3.62.31 3.62z"}})])])])
          )
        }
      }
    